"use client";

import { useSearchTerm, useIsLoading, usePagination, useProductAllInfo, useProductDetailInfoList, useIsShowModal } from '@/app/context/StateProvider';
import { ProductEntry } from '@/types/Product';
import { useRouter } from 'next/navigation';
import LoadingEffect from '@/app/components/loading/LoadingEffect';
export default function HandleClientComponent({
  searchTerm,
  searchResult,
  tagList,
  productAllInfoList
}: {
  searchTerm: string;
  searchResult: ProductEntry[];
  tagList: string[];
  productAllInfoList: any[];
}) {
  const [searchTermState, setSearchTerm] = useSearchTerm();
  const [productAllInfo, setProductAllInfo] = useProductAllInfo();
  const [isLoading, setIsLoading] = useIsLoading();
  const [pagination, setPagination] = usePagination();
  const [, setIsShowModal] = useIsShowModal();
  const router = useRouter();
  if (searchTerm && searchTerm !== "") {
    //console.log("searchTerm from dynamic search", decodeURIComponent(searchTerm));
    //setSearchTerm(decodeURIComponent(searchTerm));
  }
  if (searchResult && tagList.length !== 0 && searchResult.length !== 0) {
    setIsLoading(false);
  } else if (searchResult.length === 0) {
    setIsShowModal(true);
    setIsLoading(false);
    setSearchTerm("");
    router.push(`/searchResultInvalid`);
    console.log("client search page, no product information found");
  }
  ;
  if (productAllInfoList.length === 0) {
    router.push(`/searchResultInvalid`);
  }
  return isLoading ? <LoadingEffect /> : null;
}
;